export default [
    {
        id: 'Demanda',
        chavePermissao: 'BancoDemanda',
        title : "Banco de demandas",
        icon : "fas fa-tasks",
        order : 0,
        to : "/demanda",
        role : [],
        expand:false
    },    
    {
        id: 'PropostaTodasEmpresas',
        chavePermissao: 'Proposta',
        title : "Propostas",
        icon : "fa-solid fa-comments-dollar",
        order : 0,
        to : "/proposta_todos",
        role : [],
        expand:false,
    },
    {
        id: 'PropostaEmpresaProponente',
        chavePermissao: 'Proposta',
        title : "Propostas",
        icon : "fa-solid fa-comments-dollar", 
        order : 0,
        to : "/proposta_proponente",
        role : [],
        expand:false,
        excetoAdmin : true
    },
    {
        id: 'PropostaEmpresaCooperada',
        chavePermissao: 'Proposta',
        title : "Propostas cooperadas",
        icon : "fa-solid fa-link", 
        order : 0,
        to : "/proposta_proponente_cooperada",
        role : [],
        expand:false,        
        excetoAdmin : true
    },
    {
        id: 'PropostaEmpresaExecutora',
        chavePermissao: 'Proposta',
        title : "Minhas propostas",
        icon : "fa-solid fa-comments-dollar", 
        order : 0,
        to : "/proposta_executora",
        role : ['executora'],
        expand:false,        
        excetoAdmin : true
    },
    {
        id: 'PropostaEmpresaExecutora',
        chavePermissao: 'Proposta',
        title : "Propostas associadas",
        icon : "fa-solid fa-link", 
        order : 0,
        to : "/proposta_executora_associada",
        role : ['executora'],
        expand:false,
        excetoAdmin : true
    },
    {
        id: 'PlanejamentoEstrategico',
        chavePermissao: 'PlanejamentoEstrategico',
        title : "Planejamento estratégico",
        icon : "fas fa-lightbulb",
        order : 0,
        to : "/planejamento-estrategico",
        role : [],
        expand:false
    },
    {
        id: 'projetos',
        title : "Projetos",
        icon : "fa-solid fa-diagram-project",
        order : 0,
        children : [
            {
                id: 'Projeto',
                chavePermissao: 'ProjetosPd',
                title : "Meus projetos P&D",
                icon : "",
                order : 0,
                to : "/projeto",
                role : ['proponente'],
                excetoAdmin : true
            },
            {
                id: 'ProjetoEmpresaExecutoraCriadora',
                chavePermissao: 'ProjetosPd',
                title : "Projetos P&D",
                icon : "",
                order : 0,
                to : "/projeto_executora_criadora",
                role : ['executora'],
                excetoAdmin : true
            },
            {
                id: 'ProjetoEmpresaExecutora',
                chavePermissao: 'ProjetosPd',
                title : "Projetos P&D associados",
                icon : "",
                order : 0,
                to : "/projeto_executora_associada",
                role : ['executora'],
                excetoAdmin : true
            },
            {
                id: 'ProjetoEmpresaCooperada',
                chavePermissao: 'ProjetosPd',
                title : "Projetos P&D cooperados",
                icon : "",
                order : 0,
                to : "/projeto_proponente_cooperada",
                role : [],
                excetoAdmin : true
            },
            {
                id: 'ProjetoTodasEmpresas',
                chavePermissao: 'ProjetosPd',
                title : "Projetos P&D",
                icon : "",
                order : 0,
                to : "/projeto_todos",
                role : [],
            },
            
            {
                id: 'ProjetoGestao',
                chavePermissao: 'ProjetosGestao',
                title : "Projetos de gestão / GPPDI",
                icon : "",
                order : 0,
                to : "/projeto_gestao_proponente",
                role : [],
                excetoAdmin : true
            },
            {
                id: 'ProjetoGestaoCooperada',
                chavePermissao: 'ProjetosGestao',
                title : "Projetos de gestão / GPPDI cooperada",
                icon : "",
                order : 0,
                to : "/projeto_gestao_cooperada",
                role : [],   
                excetoAdmin : true
            },
            {
                id: 'ProjetoGestaoTodos',
                chavePermissao: 'ProjetosGestao',
                title : "Projetos de gestão / GPPDI",
                icon : "",
                order : 0,
                to : "/projeto_gestao_todos",
                role : [],
            },
            {
                id: 'ProjetoRN219',
                chavePermissao: 'ProjetosRn219',
                title : "Projetos encerrados RN 219",
                icon : "",
                order : 0,
                to : "/projeto_rn_219",
                role : [],
                badge : {
                    variant : 'warning',
                    text : "Regra antiga"
                }
            },
            {
                id: 'ProjetoRN316',
                chavePermissao: 'ProjetosRn316',
                title : "Projetos encerrados RN 316",
                icon : "",
                order : 0,
                to : "/projeto_316",
                role : [],
                badge : {
                    variant : 'success',
                    text : "Regra nova"
                }
            },
        ],
        role : [],
        expand:false
    },
    {
        id: 'armazenamento',
        title : "Armazenamento",
        icon : "fas fa-archive",
        order : 0,
        children : [
            {
                id: 'BoletoFNDCT',
                chavePermissao: 'Fndct',
                title : "FNDCT",
                icon : "",
                order : 0,
                to : "/fndct",
                role : [],
            },
            {
                id: 'BoletoCDE',
                chavePermissao: 'Cde',
                title : "CDE",
                icon : "",
                order : 0,
                to : "/cde",
                role : [],
            },
            {
                id: 'BoletoMME',
                chavePermissao: 'Mme',
                title : "MME",
                icon : "",
                order : 0,
                to : "/mme",
                role : [],
            }
        ],
        role : [],
        expand:false
    },
    {
        id: 'ModeloDocumento',
        chavePermissao: 'ModelosDocumentos',
        title : "Modelos de documentos",
        icon : "fas fa-file-alt",
        order : 0,
        to : "/documentos",
        role : [],
        expand:false
    },
    {
        id: 'financeiro',
        title : "Financeiro",
        icon : "fas fa-file-invoice-dollar",
        order : 0,
        children : [
            {
                id: 'MovimentacaoFinanceira',
                chavePermissao: 'MovimentacaoFinanceira',
                title : "Movimentação financeira",
                order : 0,
                to : "/movimentacao_financeira",
                role : [],
                expand:false
            },
            {
                id: 'ProjecaoFinanceira',
                chavePermissao: 'ProjecaoFinanceira',
                title : "Projeção financeira",
                order : 0,
                to : "/projecao_financeira",
                role : [],
                expand:false
            },
        ],
        role : [],
        expand:false
    },
    
]